import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d9f1aa3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-link-button print--hide" }
const _hoisted_2 = ["href"]

import { recProps } from 'vue/applications/frontend/mixins/rec-component';
  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-link-button',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["exam-button", [_unref(themingCssClass)('border'), _unref(themingCssClass)('hover_invert'), _unref(themingCssClass)('normal')]]),
      href: _ctx.description.target
    }, [
      (_ctx.description.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["frontend-icon", _ctx.description.icon])
          }, null, 2))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.description.label), 1)
    ], 10, _hoisted_2)
  ]))
}
}

})